import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListOptionsRoutingModule } from './list-options-routing.module';
import { ListOptionsComponent } from './list-options.component';
import { DevEpressCommonModule } from "../../../dev-epress-common.module";
import { DxDataGridModule, DxPopupModule, DxTextAreaModule, DxValidationSummaryModule } from 'devextreme-angular';

import { FormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        ListOptionsComponent
    ],
    imports: [
        CommonModule,
        ListOptionsRoutingModule,FormsModule,
        DevEpressCommonModule,DxDataGridModule,DxPopupModule,DxTextAreaModule,DxValidationSummaryModule
    ]
})
export class ListOptionsModule { }
